import axios from 'axios';

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  withCredentials: false,
  headers: {
    'Ocp-Apim-Subscription-Key': process.env.REACT_APP_SUBSCRIPTION_KEY,
  },
});

const axiosInstanceFEserver = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
  withCredentials: true,
});
export { axiosInstance, axiosInstanceFEserver };
